import { add } from 'mathjs';
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { ButtonUI, DialogUI, FormLabelUI, InputUI } from '../../Interface';
import { NotificationType } from '../../../config';
import addNotification from '../../../utils/addNotification';
import JMWithAccountingGroupTable from './JMWithAccountingGroupTable';
import useParam from '../../../context/ParamContext';

const JMWithAccountingGrouppedQuantityDialog = ({
  open,
  helperData,
  handleClose,
  data,
  handleFinishOperation,
  autoCompleteOptions,
  mode,
}) => {
  const { params } = useParam();
  const defValues = {
    doseNumber: '',
  };
  const [values, setValues] = useState(defValues);

  useEffect(() => {
    if (!open) {
      setValues(defValues);
    }
  }, [open]);

  const showDoseNumberField = data.some((d) =>
    helperData?.operations?.some((op) => op.operationId === d.operationId && op.showDoseNumber)
  );

  const handleClick = () => {
    if (mode === 'finish') {
      const errors = [];

      for (const [operationId, val] of Object.entries(values)) {
        const findedData = data.find((d) => d.productionoperationid.toString() === operationId.toString());

        if (!findedData) continue;

        if (params.JOBMONITOR_DISABLE_PROD_QUANTITY_VALIDATION !== 'Y') {
          if (add(Number(val.quantity || 0), Number(val.scrapQuantity || 0)) != Number(findedData.productionQuantity)) {
            errors.push(`A lejelenteni kívánt mennyiség eltér a gyártandó mennyiségtől - ${operationId}!`);
          }
        }
      }

      if (errors.length > 0) {
        for (const err of errors) {
          addNotification({
            type: NotificationType.ERROR,
            content: err,
          });
        }
        return;
      }
    }

    handleFinishOperation(values);
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Mennyiségek megadása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1500px',
          },
        },
      }}
    >
      <Box mt="1.5rem" gap="1rem">
        <JMWithAccountingGroupTable
          data={data}
          mode="quantityMode"
          valuesState={{ values, setValues }}
          autoCompleteOptions={autoCompleteOptions}
        />
        {showDoseNumberField && (
          <Box mt="1rem" width="300px">
            <InputUI
              label={<FormLabelUI text="Adagszám" />}
              onChange={(e) =>
                setValues((prev) => ({
                  ...prev,
                  doseNumber: e.target.value,
                }))
              }
            />
          </Box>
        )}
      </Box>
      <Box textAlign="center" mt="2rem">
        <ButtonUI text="Rögzítés" className="bg-success" onClick={() => handleClick()} />
      </Box>
    </DialogUI>
  );
};

export default JMWithAccountingGrouppedQuantityDialog;
